import { WorkoutCard } from './workout-card'
import { WorkoutCardContent } from './workout-card-content'
import { WorkoutCardFavoriteRemove } from './workout-card-favorite-remove'
import { WorkoutCardImage } from './workout-card-image'
import { WorkoutCardMeta } from './workout-card-meta'
import { WorkoutCardTitle } from './workout-card-title'
import React from 'react'
import { Workout } from 'src/dao/core-dao'
import { cn } from 'src/lib/utils'

interface WorkoutCardFavoritesProps {
  workout: Workout
  className?: string
  onAction: () => void
}

export const WorkoutCardFavorites = ({ workout, className, onAction }: WorkoutCardFavoritesProps): React.ReactElement => {
  return (
    <WorkoutCard
      workout={workout}
      isCompleted={false}
      className={cn('flex-1 h-full rounded-md aspect-[16/9]', className)}
      onAction={onAction}
    >
      <WorkoutCardImage>
        <WorkoutCardContent>
          <WorkoutCardFavoriteRemove />
          <div className="flex-1 flex flex-col justify-end">
            <WorkoutCardTitle />
            <WorkoutCardMeta />
          </div>
        </WorkoutCardContent>
      </WorkoutCardImage>
    </WorkoutCard>
  )
}
